
import { Show, SimpleShowLayout, TextField } from "react-admin";

export const CompanyShow = (props: any) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="name" label="Nome" />
      <TextField source="cnpj" label="CNPJ" />
    </SimpleShowLayout>
  </Show>
);
